import axios from 'axios'
import loadingGif from '../assets/loading.gif'
import loadingObj from '../utils/globalLoading';

var loading
const instance = axios.create({
    // 接口基础地址  接口的公共地址 一般域名
    // baseURL:'',
    // 超时时间

    timeout:3000000,
})
// 请求拦截器
instance.interceptors.request.use(cfg => {
     // 在请求头中添加 token
    if (localStorage.getItem('token')) {
        cfg.headers['token'] = localStorage.getItem('token');
         //cfg.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
    }else{
        // alert('未登录，请登录！')
        // location.href = '/login'
    }
    loadingObj.showFullScreenLoading();
    // 封装请求加载状态
    // loading = Loading.service({
    //     lock: true, 
    //     background: 'rgba(0, 0, 0, 0.7)',
    //     text: "loading...",
    //     spinner: loadingGif,
    // });
    // config.loading = true
    // config.loadingImage = require('../assets/loading.gif') 
    return cfg
},error => {
     loadingObj.tryHideFullScreenLoading();
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(res => {
    loadingObj.tryHideFullScreenLoading();
    if(res.data.code === 400){
        alert(res.data.message)
        // this.$message.error(res.data.message);
        location.href = '/login'
        localStorage.clear();
    }
    setTimeout(() => {
        // 请求加载状态停止
        // loading.close()
    }, 700)

    return res
},error => {
        loadingObj.tryHideFullScreenLoading();
         // 处理 HTTP 错误（如 401 跳转登录）
        if (error.response?.status === 400) { // code = 400 没token
            Message({
                message: '登录已过期',
                type: 'error',
                customClass: 'global-message-zindex'  // 添加自定义样式类
            });
            router.push('/login');
        }
        return Promise.reject(error);
    }
)

export default instance